import React, { Component } from 'react'
import { Button, Col, Container, Image,  } from 'react-bootstrap'
import { BrowserRouter, Link, Routes, Route } from 'react-router-dom'
import Apnapolicy from '../Images/Apnapolicy.png'
import './headerOne.css'
import './header.css'

// import certificate from '../Images/certificate.png'

import Apnapolicypage from '../SidebarComponent/Apnapolicypage'
// import Carousel from 'react-multi-carousel';
  import apnapolicycertificate from '../Images/apnapolicycertificate.jpg'
import configData from "../config.json";
import Abharegister from '../SidebarComponent/ABHA/Abharegister'
import AbhaAddressCreation from '../SidebarComponent/ABHA/AbhaAddressCreation'
import AbhaProfile from '../SidebarComponent/ABHA/AbhaProfile'
import Abhaaddressverification from '../SidebarComponent/ABHA/Abhaaddressverification'
import AbhaAddressChange from '../SidebarComponent/ABHA/AbhaAddressChange'
import ExistingAbha from '../SidebarComponent/ABHA/ExistingAbha'
import UpdateProfile from '../SidebarComponent/ABHA/UpdateProfile'
import ConsentCollectionAadhaar from '../SidebarComponent/ABHA/ConsentCollectionAadhaar'
import AadharAuthentication from '../SidebarComponent/ABHA/AadharAuthentication'
import MobileOtp from '../SidebarComponent/ABHA/MobileOtp'
import AbhaVerification from '../SidebarComponent/ABHA/AbhaVerification'
import MobileAuthentication from '../SidebarComponent/ABHA/MobileAuthentication'
import Mobilenumberotp from '../SidebarComponent/ABHA/Mobilenumberotp'
import Mobileabhaprofile from '../SidebarComponent/ABHA/Mobileabhaprofile'
import ABHANumberVerification from '../SidebarComponent/ABHA/ABHANumberVerification'
import Abhaaddressverificationotp from '../SidebarComponent/ABHA/Abhaaddressverificationotp'
import AbhaverificationNumberOtp from '../SidebarComponent/ABHA/AbhaverificationNumberOtp'
import Abhamobileprofile from '../SidebarComponent/ABHA/Abhamobileprofile'
import ABHANumberProfile from '../SidebarComponent/ABHA/ABHANumberProfile'
import AbhaNumberverifyotp from '../SidebarComponent/ABHA/AbhaNumberverifyotp'
import AbhacreationAN from '../SidebarComponent/ABHA/AbhacreationAN'
import AbhaAddressverfi from '../SidebarComponent/ABHA/AbhaAddressverfi'
import Abhacreation from '../SidebarComponent/ABHA/Abhacreation'
import ExistingABHAVerification from '../SidebarComponent/ABHA/ExistingABHAVerifcation'
import Downloads from '../SidebarComponent/ABHA/Downloads'
import Aadhaarcollection from '../SidebarComponent/ABHA/Aadhaarcollection'
import Update from '../SidebarComponent/ABHA/Update'
import ABHAVerificationflow from '../SidebarComponent/ABHA/ABHAVerificationflow'
import UpdateProfileABHA from '../SidebarComponent/ABHA/UpdateProfileABHA'
import Abhaaddressverfiotp from '../SidebarComponent/ABHA/Abhaaddressverfiotp'
import Mobileprofileupdate from '../SidebarComponent/ABHA/Mobileprofileupdate'
import Abhaaddressprofile from '../SidebarComponent/ABHA/Abhaaddressprofile'
import MobileAbhasuggestions from '../SidebarComponent/ABHA/MobileAbhasuggestions'
import AadhaarcollectionOTP from '../SidebarComponent/ABHA/AadhaarcollectionOTP'
import Aadhaarabhaprofile from '../SidebarComponent/ABHA/Aadhaarabhaprofile'

// import NotFound from './NotFound'

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      currentYear: new Date().getFullYear(),
      //showFooter: false, // Initially, the footer is not shown
      isImageClicked: false,
    }
  }
//image event
handleImageClick = () => {
  this.setState((prevState) => ({
    isImageClicked: !prevState.isImageClicked,
  }));
};

  handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = '/';

  }
  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  handleLinkClick = () => {
    setTimeout(() => {
      this.setState({ show: false });
    }, 1000);
  };

  renderPageNotFound() {
    const { match } = this.props;

    if (match && match.isExact === false) {
      return (
        <div>
          <h1>Page Not Found</h1>
          <p>The requested page "{this.props.location.pathname}" does not exist.</p>
        </div>
      );
    }
  }


  handleLinkClickOne = () => {
    // Replace "_blank" with the name of the new window or tab, if needed
    window.open("https://app.apnapolicy.co.in/", '_blank');
  };


  handleclick=()=>{
    window.location="./abhanumberverification"
  }
  // handleAAclick=()=>{
  //   window.location="./abhaaddressverfi"
  // }
  // handleAAclick=()=>{
  //   window.location="./abhacreation"
  // }
  handleHomeclick=()=>{
    sessionStorage.clear();
    localStorage.clear();
    window.location="./Abharegister"
  }
  handlelogoutclick = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "./Abharegister";
  };
  render() {
    const { isImageClicked } = this.state;
    
    return (
      <div className='app'>
       <BrowserRouter>
          <header className='d-flex'>
             <nav className="navbar navbar-expand-lg offcanvas-wrapper navbar-dark">  
              <Link to='https://www.apnapolicy.co.in/'>
                <Image
                  src={Apnapolicy}
                  className='navbar-brand pe-3 ps-4 ps-lg-2'
                /></Link>
                

            </nav>
           <Col className='d-flex justify-content-end'>
           <Button className='rounded-0 m-3' onClick={this.handleHomeclick}>Home</Button>
           {/* <Button className='rounded-0 m-3' onClick={this.handleclick}>ABHA Verification</Button> */}
           {/* <Button className='rounded-0 m-3' onClick={this.handleAAclick}>ABHA Verification</Button> */}

           <Button className='rounded-0 m-3 bi bi-box-arrow-right' onClick={this.handlelogoutclick}></Button>
           {/* <Button className='rounded-0 m-3' variant='success'>Download ABHA Card</Button> */}
           </Col>
          </header>
          <main className='mt-5 mb-5'>                
                <div className="container">
                  <Routes>
                    
                    {/* <Route path='/' element={<MainPage />} /> */}
                   
                    <Route
                        path="/"
                        element={<Abharegister/>}
                      ></Route>
                      <Route path='aadhaarauthentication' element={<AadharAuthentication/>}></Route>
                   <Route
                        path="abhaaddresscreation"
                        element={<AbhaAddressCreation />}
                      ></Route>
                        <Route
                          path="mobileAuthentication"
                          element={<MobileAuthentication />}
                        ></Route>
                      <Route
                        path="abharegister"
                        element={<Abharegister />}
                      ></Route>
                      <Route
                        path="abhaprofile"
                        element={<AbhaProfile/>}
                      ></Route>
                      <Route
                        path="abhaaddressverification"
                        element={<Abhaaddressverification/>}
                      ></Route>
                      <Route
                        path="abhaverification"
                        element={<AbhaVerification/>}
                      ></Route>
                      
                      <Route
                        path="abhaaddresschange"
                        element={<AbhaAddressChange />}
                      ></Route>
                      <Route
                        path="existingabha"
                        element={<ExistingAbha />}
                      ></Route>
                      <Route
                        path="updateprofile"
                        element={<UpdateProfile />}
                      ></Route>
                       <Route
                        path="consentcollectionaadhaar"
                        element={<ConsentCollectionAadhaar />}
                      ></Route>
                        <Route path="mobileotp" element={<MobileOtp />}></Route>
                        <Route path="mobilenumberotp" element={<Mobilenumberotp/>}></Route>
                        <Route path="mobileabhaprofile" element={<Mobileabhaprofile/>}></Route>
                        <Route path='abhanumberverification' element={<ABHANumberVerification/>}></Route> 
                        <Route path='abhaaddressverificationotp' element={<Abhaaddressverificationotp/>}></Route>
                        <Route path="abhamobileprofile" element={<Abhamobileprofile/>}/>
                        <Route path='/apnapolicypage' element={Apnapolicypage}></Route>
                        <Route path='/abhaverificationnumberOtp' element={<AbhaverificationNumberOtp/>}></Route>
                        <Route path='/abhanumberprofile' element={<ABHANumberProfile/>}></Route>
                        <Route path='/abhanumberverifyotp' element={<AbhaNumberverifyotp/>}></Route>
                        <Route path='/abhaaddressverfi' element={<AbhaAddressverfi/>}></Route>
                        <Route path='/abhacreation' element={<Abhacreation/>}></Route>
                        
                        <Route path='/existingabhaverification' element={<ExistingABHAVerification/>}></Route>
                        <Route path='/abhacreationan' element={<AbhacreationAN/>}></Route>
                        <Route path='/download' element={<Downloads/>}></Route>
                        <Route path='/aadhaarcollection' element={<Aadhaarcollection/>}></Route>
                        <Route path="/update" element={<Update/>}></Route>
                        <Route path='/abhaverificationflow' element={<ABHAVerificationflow/>}></Route>
                        <Route path='/updateprofileabha' element={<UpdateProfileABHA/>}></Route>
                        <Route path='/abhaaddressverfiotp' element={<Abhaaddressverfiotp/>}></Route>
                        <Route path='/mobileprofileupdate' element={<Mobileprofileupdate/>}></Route>
                          <Route path="/abhaaddressprofile"  element={<Abhaaddressprofile/>}></Route>
                          <Route path='/mobileabhasuggestions' element={<MobileAbhasuggestions/>}></Route>
                          <Route path='/aadhaarcollectionotp' element={<AadhaarcollectionOTP/>}/>
                          <Route path="/aadhaarabhaprofile" element={<Aadhaarabhaprofile/>} />
                    </Routes>
                  </div>
          </main>
          
           <footer>
            <section id='footer' >
              <Container> 
              
                <div className='row pt-2'>
                  <div className='col-xs-12 col-sm-12 col-md-5 mt-2'>
                    <ul className='list-unstyled list-inline social text-left'>
                      <li>
                        <Link to="/"><Image
                          style={{ "width": "200px" }}
                          src={Apnapolicy}
                          alt=''
                        /></Link><br />
                      </li>
                      <li>201/2 2nd Floor,Mandhana Towers,</li>
                      <li> Ameerpet,Hyderabad,</li>
                      <li> Telangana,India - 500016</li>
                      <li>
                      <i className="fa fa-phone" aria-hidden="true"></i>&nbsp;&nbsp;<Link to='/Tel:+918978728484'>+91 8978728484</Link>
                      </li>
                      <li>
                      </li>
                    </ul>
                  </div>
                
                  <div className='col-xs-12 col-sm-12 col-md-2 mt-2 text-start ourPolicies'>
                    <h4>Policies</h4>                
                    <ul>
                      <li>
                        
                      <a
                        href={configData.api_url + "uploads/privacy-policy.pdf"}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Privacy Policy
                    </a>
                    
                      </li>
                      <li>
                          
                          <a
                            href={configData.api_url + "uploads/tou.pdf"}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Terms of Use
                          </a>
                          
                      </li>
                      <li>
                      
                      <a
                  href={configData.api_url + "uploads/disclaimer.pdf"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Disclaimer
                </a>{" "}
                
                </li>
                    </ul>
                  </div>
                  <div className='col-xs-12 col-sm-12 col-md-5 mt-2 '>
                  {isImageClicked ? (
                    <div className='centered-image-overlay' onClick={this.handleImageClick}>
                      <img
                      src={apnapolicycertificate}
                      alt='Certificate' 
                        className='centered-image'
                      />
                    </div>
                  ) : (
                    <img
                    src={apnapolicycertificate}
                    alt='Certificate' 
                    //style={{"width":"100%"}}
                    style={{ "height":"182px","width":"255px" }}
                      onClick={this.handleImageClick}
                    />
                  )}   
                  </div>
                </div>
              </Container>
            </section>
            <section className='ourCopyright'>
              <Container>
                <div className='row'>
                  <div className="col-md-12 text-center">
                    <p className="">Insurance is the subject matter of solicitation.
                    All product information displayed is from the respective Insurance companies. 
                    <br/> All Right's Reserved Apnapolicy Insurance Brokers Private Limited &#169; {this.state.currentYear}.</p>
                  </div>
                </div>
              </Container>
            </section>
          </footer>
        </BrowserRouter>
      </div>
    )
  }
}
